import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import api, { IMAGE_BASE_URL } from "../../api/Api.js";
import { Link } from "react-router-dom";
import { ArrowLeft,Search } from "lucide-react";
import { useNavigate } from "react-router-dom";
import "./VisaAssistanceManage.css";
import Swal from "sweetalert2";
const BlogManage = () => {
   const urlLink='https://www.patratravels.com/visa/country/';
const navigate = useNavigate();
const [searchTerm, setSearchTerm] = useState("");
const imagePath = `${IMAGE_BASE_URL}/uploads/visa/`;
const [getblogdata, setblogdata] = useState([]);
const [getPageId, setPageId] = useState([]);
const [currentPage, setCurrentPage] = useState(1);
const [blogsPerPage] = useState(10); // show 6 blogs per page
useEffect(() => {
fetchBlogData();
}, []);
const handleViewDetails = (pageID) => {
navigate(`/visa-assistance-details/${pageID}`);
};
const handleDeleteBlog = async (pageID) => {
const confirm = await Swal.fire({
title: "Delete Visa Assistance?",
text: "Do you want to delete this Visa Assistance?",
icon: "warning",
showCancelButton: true,
confirmButtonText: "Yes Delete"
});
if (!confirm.isConfirmed) return;
try {
const res = await api.delete(
`/adminVisaAssistanc/deleteVisa/${pageID}`
);
if (res.data.success) {
Swal.fire(
"Deleted!",
"Visa Assistance deleted successfully",
"success"
);
fetchBlogData();
}
} catch (error) {
toast.error("Failed to delete Visa Assistance");
}
};
const handleEditPage = (pageID) => {
navigate(`/edit-visa-assistance/${pageID}`);
};
// Fetch Page Data
const fetchBlogData = async () => {
try {
const res = await api.get("/adminVisaAssistanc/getVisaData");
const data = res.data?.data || [];
setblogdata(data);
} catch (error) {
toast.error("Failed to load Visa Assistance data");
}
};
const handleStatusChange = async (id, is_active) => {
try {
await api.put("/adminVisaAssistanc/visa-status", { id, is_active});
toast.success("Status updated");
fetchBlogData(); // Revert on error
} catch {
toast.error("Failed to update status");
fetchBlogData(); // Revert on error
}
};
const backpage = async (blogId) => {
location.reload();
}

const updateSortOrder = async (id, sort_order) => {
  try {
    await api.put("/adminVisaAssistanc/update-visa-sort-order", {
      id,
      sort_order,
    });

    toast.success("Sort order updated");
    fetchBlogData();
  } catch (error) {
    toast.error("Failed to update sort order");
  }
};



// const indexOfLastBlog = currentPage * blogsPerPage;
// const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
// const currentBlogs = getblogdata.slice(indexOfFirstBlog, indexOfLastBlog);
// const totalPages = Math.ceil(getblogdata.length / blogsPerPage);


 // =========================
  // FILTER & SEARCH
  // =========================
  const filteredCountries = getblogdata.filter((cat) => {
    const term = searchTerm.trim().toLowerCase();

    const countryName = String(cat.title || "").toLowerCase();
    const countrySlug = String(cat.country || "").toLowerCase();

    return (
      countryName.includes(term) ||
      countrySlug.includes(term)
    );
  });

  // =========================
  // PAGINATION
  // =========================
  const totalPages = Math.ceil(filteredCountries.length / blogsPerPage);

  const indexOfLast = currentPage * blogsPerPage;
  const indexOfFirst = indexOfLast - blogsPerPage;

  const currentItems = filteredCountries.slice(
    indexOfFirst,
    indexOfLast
  );

  // Search change hone par first page par jaayein
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

return (
<div className="container-fluid py-3 bg-white min-vh-100">
   <div className="card shadow-sm border-0 mb-4 bg-primary-subtle rounded-3">
      <div className="card-body d-flex justify-content-between">
         <h4 className="fw-bold">Visa Assistance Manage</h4>
         <div style={{display:"flex"}}>
         <div className="input-group input-group-sm" style={{width: '200px',marginRight:"10px"}}>
                         <span className="input-group-text bg-white"><Search size={16}/></span>
                         <input 
                           type="text" 
                           className="form-control" 
                           placeholder="Search..." 
                           value={searchTerm} 
                           onChange={handleSearch}
                         />
         </div>
         <Link
            to={"/add-visa-assistance"}
            className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-2"
            >
         <ArrowLeft size={16} />
         Add 
         </Link>
         </div>
      </div>
   </div>
   {/* Table */}
   <div className="card shadow-sm border-0 rounded-3 overflow-hidden">
      <div className="table-responsive">
         <table className="table table-hover table-sm align-middle mb-0"  style={{
         tableLayout: "fixed",
         width: "100%"
         }}>
         <thead className="bg-light">
            <tr>
               <th className="text-center"  style={{width:"5%"}}>Sl. No.</th>
               <th  style={{width:"80px"}}> Sort</th>
               <th className="text-center" style={{width:"30%"}}>Title</th>
               <th className="text-center" style={{width:"12%"}}>Country</th>
               <th className="text-center" style={{width:"12%"}}>Link</th>
               <th className="text-center" style={{width:"7%"}}>View</th>
               <th className="text-center" style={{width:"10%"}}>Date</th>
               <th className="text-center" style={{width:"10%"}}>Status</th>
               <th className="text-center" style={{width:"10%"}}>Action</th>
            </tr>
         </thead>
         <tbody>
            {currentItems.length === 0 ? (
            <tr>
               <td colSpan="7" className="text-center py-5 text-muted">
                  Data Not Found.
               </td>
            </tr>
            ) : (
            currentItems.map((blog, index) => (
            // className="title-cell"
            // className="subtitle-cell"
            <tr key={index}>
               <td className="text-center" >{index + 1}</td>
                                  <td>
<input
  type="number"
  className="form-control form-control-sm"
  defaultValue={blog.sort_order}
  onBlur={(e) =>
    updateSortOrder(blog.visa_id, e.target.value)
  }

/>
</td>
               <td>{blog.title}</td>
               <td className="text-center">
                  {blog.country
                  ?.replace(/-/g, " ")
                  ?.replace(/\b\w/g, (char) => char.toUpperCase())
                  }
               </td>
               <td>
                                         <a
    target="_blank"
    rel="noopener noreferrer"
    href={`${urlLink}${blog.country}`}
  >
{blog.country}
  </a>
               </td>
               <td className="text-center">
                  <button
                     className="btn btn-sm btn-success me-2"
                     onClick={() => handleViewDetails(blog.visa_id)}
                  >
                  <i class="fa fa-eye" aria-hidden="true"></i>
                  </button>
               </td>
               <td className="text-center">
                  {new Date(blog.addedDt)
                  .toLocaleString("en-GB", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                  hour12: false
                  })
                  .replace(/\//g, "-")
                  .replace(",", "")}
               </td>
               <td className="text-center">
                  <select
                  className={`form-select form-select-sm border-0 fw-bold ${blog.is_active == 1 ? "text-success bg-success-subtle" : "text-danger bg-danger-subtle"}`}
                  style={{ width: "100px", margin: "0 auto", cursor: "pointer" }}
                  value={blog.is_active}
                  onChange={(e) => handleStatusChange(blog.visa_id, e.target.value)}
                  >
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                  </select>
               </td>
               <td className="text-center">
                  <button
                     className="btn btn-sm btn-primary me-2"
                     onClick={() => handleEditPage(blog.visa_id)}
                  >
                  <i className="fa fa-pencil" aria-hidden="true"></i>
                  </button>
                  <button className="btn btn-sm btn-danger"
                     onClick={() => handleDeleteBlog(blog.visa_id)}
                  >
                  <i class="fa fa-trash" aria-hidden="true"></i>
                  </button>
               </td>
            </tr>
            ))
            )}
         </tbody>
         </table>
         <div className="d-flex justify-content-center mt-3">
            <nav>
               <ul className="pagination">
                  <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                  <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)}>
                  Previous
                  </button>
                  </li>
                  {Array.from({ length: totalPages }, (_, i) => (
                  <li key={i} className={`page-item ${currentPage === i + 1 ? "active" : ""}`}>
                  <button className="page-link" onClick={() => setCurrentPage(i + 1)}>
                  {i + 1}
                  </button>
                  </li>
                  ))}
                  <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                  <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)}>
                  Next
                  </button>
                  </li>
               </ul>
            </nav>
         </div>
      </div>
   </div>
</div>
);
};
export default BlogManage;